import React from 'react'
import styled from '@emotion/styled'
import { colors } from 'styles-resources'
import { FormattedMessage } from 'react-intl'
import TagDefault from './TagDefault'

const TagFinal = styled(({ className }) => (
  <TagDefault small className={className}>
    <span>
      <FormattedMessage id="courses.course.skills.tag_label.final" />
    </span>
  </TagDefault>
))`
  color: ${colors.white};
  background-color: ${colors.midGray};
  border: 1px solid ${colors.midGray};
`

export default TagFinal
